(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const setText = (element, value) => {
    if (element && normalize(element.textContent) !== normalize(value)) element.textContent = value;
  };

  function replaceTextNodeContaining(root, needle, replacement, decorate) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if ((node.nodeValue || '').includes(needle)) {
        node.nodeValue = replacement;
        if (decorate && node.parentElement) decorate(node.parentElement);
        return;
      }
    }
  }

  function optimizeLegacyProductImages() {
    const widths = [360, 540, 720, 900, 1200];
    document.querySelectorAll('.smash-why__image, .smash-story__image').forEach((image) => {
      const original = image.getAttribute('src');
      if (!original || !original.includes('cdn.shopify.com')) return;

      const url = new URL(original, location.href);
      url.searchParams.delete('width');
      const base = url.toString();
      const makeUrl = (width) => {
        const candidate = new URL(base);
        candidate.searchParams.set('width', width);
        return candidate.toString();
      };

      image.src = makeUrl(900);
      image.srcset = widths.map((width) => `${makeUrl(width)} ${width}w`).join(', ');
      image.sizes = '(max-width: 749px) calc(100vw - 28px), 50vw';
      image.loading = 'lazy';
      image.decoding = 'async';
    });
  }

  function polishProduct() {
    const main = document.querySelector("main[data-template^='product']");
    if (!main) return;

    optimizeLegacyProductImages();

    replaceTextNodeContaining(main, '5.0 — Better than your smash.', ' MADE FOR RACKET PEOPLE', (parent) => {
      parent.classList.add('sc-product-kicker');
      const starSpan = parent.querySelector('span');
      if (starSpan) setText(starSpan, '✦');
    });

    main.querySelectorAll('span').forEach((span) => {
      if (normalize(span.textContent) === 'Less than 1% of customers use our money back guarantee.') {
        const box = span.parentElement;
        if (box && !box.classList.contains('sc-return-promise')) {
          box.className = 'sc-return-promise';
          box.innerHTML = '<span class="sc-return-promise__mark">↺</span><span class="sc-return-promise__text">30-DAY RETURNS · SIMPLE.</span>';
        }
      }
    });

    replaceTextNodeContaining(main, 'Keep The SMASH', 'ONE MORE FOR THE ROTATION', (parent) => {
      setText(parent, 'ONE MORE FOR THE ROTATION');
    });

    setText(main.querySelector('.smash-why__subtitle'), 'Made for match days, post-match plans and everything in between.');

    const whyTitles = main.querySelectorAll('.smash-why__reason-title');
    const whyBodies = main.querySelectorAll('.smash-why__reason-text');
    const titles = [
      'COMFORT FOR THE WHOLE RACKET-SPORT ROUTINE',
      'RACKET CULTURE, NOT GENERIC SPORTS MERCH',
      'REAL SUPPORT WHEN YOU NEED IT'
    ];
    const bodies = [
      'Comfortable cotton for match day, the drive home and the “one more game” that turns into three.',
      'Designs built around the jokes, habits and obsession racket people actually recognize.',
      'Questions about your order, sizing or delivery? Message us and we’ll help you sort it out.'
    ];
    whyTitles.forEach((el, index) => { if (titles[index]) setText(el, titles[index]); });
    whyBodies.forEach((el, index) => { if (bodies[index]) setText(el, bodies[index]); });

    main.querySelectorAll('p').forEach((p) => {
      const text = normalize(p.textContent);
      if (text === 'HOW NOT TO RUIN YOUR NEW FAVORITE T-SHIRT') {
        const container = p.parentElement;
        if (container && !container.dataset.scCareCopy) {
          container.innerHTML = '<p><strong>KEEP THE PRINT LOOKING FRESH.</strong></p><p>Wash cold, inside out, with mild detergent. Skip bleach and fabric softener.</p><p>Air dry or tumble dry low. Don’t iron directly over the print.</p>';
          container.dataset.scCareCopy = '1';
        }
      }
      if (text === 'GOOD THINGS TAKE TIME. BUT NOT TOO MUCH.') {
        const container = p.parentElement;
        if (container && !container.dataset.scShippingCopy) {
          container.innerHTML = '<p><strong>SHIPPING & RETURNS, KEPT SIMPLE.</strong></p><p>Free shipping on orders over $75. Orders typically ship within 7 days, with tracking sent by email.</p><p>If something arrives damaged, defective or incorrect, contact us within 30 days of purchase and we’ll help make it right.</p><p>Items must be unused and in the same condition you received them.</p>';
          container.dataset.scShippingCopy = '1';
        }
      }
    });

    main.querySelectorAll('.hts-faq__answer').forEach((answer) => {
      if (normalize(answer.textContent).includes('two T-shirts might be the perfect excuse')) {
        answer.innerHTML = 'Free shipping applies automatically once your order reaches <strong>$75</strong>.';
      }
    });
  }

  const run = () => window.requestAnimationFrame(polishProduct);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('pageshow', run);
  document.addEventListener('shopify:section:load', run);
})();
